export default "__VITE_PUBLIC_ASSET__cf837343__"